(function () {
  if (!window.BORA_PRODUCT) return;
  var PRODUCT = window.BORA_PRODUCT;
  var variants = PRODUCT.variants;

  // Matches the store format "€{{amount_with_comma_separator}}" (e.g. €2.100,00).
  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return '€' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function sizedSrc(src, width) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  var form = qs('[data-pdp-form]');
  var priceEl = qs('[data-pdp-price]');
  var compareEl = qs('[data-pdp-compare]');
  var saleEl = qs('[data-pdp-sale]');
  var variantInput = qs('[data-pdp-variant-id]');
  var atcBtn = qs('[data-pdp-atc]');
  var atcText = qs('[data-pdp-atc-text]');
  var buyNowLink = qs('[data-pdp-buy-now]');
  var stickyBar = qs('[data-pdp-sticky]');
  var stickyPrice = qs('[data-pdp-sticky-price]');
  var stickyAtc = qs('[data-pdp-sticky-atc]');
  var liveRegion = qs('[data-pdp-live]');
  var addIcon = qs('[data-pdp-add-icon]');
  var galleryMain = qs('#pdp-gallery-main img');
  var notifyLink = qs('[data-pdp-notify]');

  var ADD_TEXT = window.BORA_PDP_I18N.add_to_cart;
  var OOS_TEXT = window.BORA_PDP_I18N.oos;
  var CHECKOUT_BASE = window.BORA_PDP_ROUTES.cart_url + '/';

  function announce(msg) {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    requestAnimationFrame(function () { liveRegion.textContent = msg; });
  }

  function getSelectedOptions() {
    var opts = [];
    qsa('[data-option-position]', form).forEach(function (group) {
      var checked = qs('input[type="radio"]:checked', group);
      opts.push(checked ? checked.value : null);
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return (!opts[0] || v.option1 === opts[0]) &&
             (!opts[1] || v.option2 === opts[1]) &&
             (!opts[2] || v.option3 === opts[2]);
    });
  }

  var currentVariant = PRODUCT.variants.find(function (v) { return String(v.id) === (qs('[data-pdp-variant-id]') || {}).value; }) || PRODUCT.variants[0];
  var qtyInput = form ? qs('input[name="quantity"]', form) : null;

  // "Bli tani" goes straight to checkout via a cart permalink; it must carry
  // the chosen quantity, not always 1.
  function syncBuyNow() {
    if (!buyNowLink || !currentVariant) return;
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    buyNowLink.href = CHECKOUT_BASE + currentVariant.id + ':' + qty;
  }

  function updateDOM(variant) {
    if (!variant) return;
    currentVariant = variant;

    if (variantInput) variantInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.textContent = hasSale ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !hasSale;
    }
    if (saleEl) saleEl.hidden = !hasSale;

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.type = 'submit';
        if (atcText) atcText.textContent = ADD_TEXT;
        if (addIcon) addIcon.hidden = false;
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.type = 'button';
        if (atcText) atcText.textContent = OOS_TEXT;
        if (addIcon) addIcon.hidden = true;
      }
      atcBtn.setAttribute('data-variant-id', variant.id);
    }

    if (buyNowLink) {
      buyNowLink.hidden = !variant.available;
      syncBuyNow();
    }

    if (notifyLink) notifyLink.hidden = !!variant.available;

    if (stickyBar) {
      stickyBar.hidden = !variant.available;
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (stickyAtc) stickyAtc.setAttribute('data-variant-id', variant.id);

    if (galleryMain && variant.featured_image && variant.featured_image.src) {
      galleryMain.removeAttribute('srcset');
      galleryMain.src = sizedSrc(variant.featured_image.src, 1000);
      qsa('.pdp__thumb').forEach(function (t) {
        var thumbSrc = t.dataset.pdpThumb || '';
        var isMatch = thumbSrc.indexOf(variant.featured_image.src.split('?')[0].split('/').pop().replace(/(_\d+x)?\.[^.]+$/, '')) > -1;
        t.classList.toggle('is-active', isMatch);
        t.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });
    }

    var priceWrap = qs('.pdp__price');
    var priceLabel = (window.BORA && window.BORA.strings && window.BORA.strings.pdpPrice) || 'Çmimi';
    if (priceWrap) priceWrap.setAttribute('aria-label', priceLabel + ': ' + formatMoney(variant.price));

    announce(variant.title + ' — ' + (variant.available ? formatMoney(variant.price) : OOS_TEXT));
  }

  if (form) {
    qsa('input[type="radio"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = getSelectedOptions();
        var v = findVariant(opts);
        if (v) updateDOM(v);
      });
    });
  }

  qsa('[data-pdp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!galleryMain) return;
      galleryMain.removeAttribute('srcset');
      galleryMain.src = btn.dataset.pdpThumb;
      qsa('.pdp__thumb').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  qsa('[data-pdp-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var max = parseInt(input.max, 10) || 99;
      var next = Math.min(max, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.pdpQty, 10)));
      input.value = next;
      syncBuyNow();
    });
  });

  if (qtyInput) qtyInput.addEventListener('input', syncBuyNow);
  syncBuyNow();
})();
